import { usePergunta } from "../contexts/PerguntaContext";
import { useSalvarConversaNoStorage } from "./SalvarConversaNoStorage";

// Envia uma mensagem do usuário a partir de um botão (ex.: as opções que a IA sugere),
// como se ele tivesse digitado.
export const useEnviarMensagem = (slugAtual: string) => {
  const { pergunta, setPergunta, conversaAtual, setContextoPendente, setErroPergunta } =
    usePergunta();
  const { salvarConversa } = useSalvarConversaNoStorage();

  return (texto: string) => {
    const limpo = texto.trim();
    if (!limpo || pergunta) return;
    salvarConversa(slugAtual, conversaAtual, { usuario: limpo });
    setContextoPendente(null);
    setErroPergunta(null);
    setPergunta(limpo);
  };
};
